import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'propertitlecase',
	standalone: true
})
export class ProperTitleCasePipe implements PipeTransform {
	private readonly lowercaseWords = new Set([
		'a',
		'an',
		'and',
		'as',
		'at',
		'but',
		'by',
		'for',
		'in',
		'nor',
		'of',
		'on',
		'or',
		'so',
		'the',
		'to',
		'up',
		'yet',
		'vs',
		'via',
		'per',
		'from',
		'with',
		'into',
		'onto'
	]);

	private capitalize(word: string): string {
		return word.charAt(0).toUpperCase() + word.slice(1);
	}

	private titleCaseWord(word: string): string {
		// Handle words with leading/trailing punctuation
		const leadingPunct = word.match(/^[^\w]+/)?.[0] || '';
		const trailingPunct = word.match(/[^\w]+$/)?.[0] || '';
		const coreWord = word.replace(/^[^\w]+|[^\w]+$/g, '');

		if (!coreWord) return word; // If no core word, return as-is

		const capitalizedCore = this.capitalize(coreWord);
		return leadingPunct + capitalizedCore + trailingPunct;
	}

	transform(value: string): string {
		if (!value) return '';

		// Split by spaces and handle punctuation properly
		const words = value.trim().toLowerCase().split(/\s+/);

		return words
			.map((word, index, arr) => {
				const isFirst = index === 0;
				const isLast = index === arr.length - 1;

				// Extract the core word without leading/trailing punctuation
				const coreWord = word.replace(/^[^\w]+|[^\w]+$/g, '');

				// If the core word is in lowercase words list, keep it lowercase
				if (coreWord && this.lowercaseWords.has(coreWord) && !isFirst && !isLast) {
					return word;
				}

				// Otherwise, title case the word
				return this.titleCaseWord(word);
			})
			.join(' ');
	}
}
